import React, { createContext, useState, useEffect } from 'react';
import { fetchConversations } from '../api/chatApi';

export const ConversationsContext = createContext();

export const ConversationsProvider = ({ children }) => {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refreshConversations = async () => {
    setLoading(true);
    try {
      const conversations = await fetchConversations();
      setConversations(conversations);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConversationsContext.Provider value={{ conversations, loading, error, refreshConversations }}>
      {children}
    </ConversationsContext.Provider>
  );
};
